<section *ngIf="showAddCard">
  <div *ngIf="!isIFrameReady" class="tw-my-8 tw-ml-[9px]">
    <span>Loding UI...</span>
  </div>

  <div #eProtectIframeTemplate [hidden]="!isIFrameReady" >
    <div #eProtectiframe class="eProtectiframe" id="eProtectiframe"></div>

    <div #btn id="btn-account" class="col-md-12">
      <ion-button type="button" class="tw-w-full tw-mb-4" id="btn-add" (click)="addCard()" data-cy="card-deposit-add-new" hidden>
        Add new card
      </ion-button>
      <ion-button type="button" class="tw-w-full tw-mb-4" id="btn-adding" hidden disabled>
        Adding new card...
        <i class="fa fa-spinner fa-spin"></i>
      </ion-button>
    </div>
  </div>
</section>
